// packages import
import { FC, useContext } from 'react'
import { Navigate, useParams } from 'react-router-dom'

// component import
import PreBills from './PreBills'
import FinalBills from './FinalBills'
import FundRequests from './FundRequests'
import PrintJobs from './PrintJobs'

// others
import { AuthContext, PreBillsContextProvider } from '../../../context'
import { FinalBillsContextProvider } from '../../../context/FinalBillsContext'
import { FundRequestsContextProvider } from '../../../context/FundRequestsContext'

const Billing: FC = (): JSX.Element => {
  const { type } = useParams<{ type: string }>()
  const { isAdmin, isAccountant, isSuperAdmin } = useContext(AuthContext)
  const canAccessPrintBills = isAdmin || isAccountant || isSuperAdmin

  switch (type) {
    case 'pre-bills':
      return (
        <PreBillsContextProvider>
          <PreBills />
        </PreBillsContextProvider>
      )
    case 'bills':
      return (
        <FinalBillsContextProvider>
          <FinalBills />
        </FinalBillsContextProvider>
      )
    case 'fund-requests':
      return (
        <FundRequestsContextProvider>
          <FundRequests />
        </FundRequestsContextProvider>
      )
    case 'print-jobs':
      return canAccessPrintBills ? <PrintJobs /> : <Navigate to="/billing/pre-bills" replace />
    default:
      return <PreBills />
  }
}

export default Billing
